module.exports = __webpack_public_path__ + "components/rewards/sport-pursuit/static/logo-90d57f58ab1cdae6a2a8370c04d50c62.webp";